export default function ChildMatchApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getChildMatchByCentre(centreId){
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/ChildMatchLookup/${centreId}`));
        });
    }

    function deleteChildMatch(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/ChildMatchLookup/${id}`));
        });
    }    
    
    function updateChildMatch(id, data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/ChildMatchLookup/${id}`, data));
        });
    }

    function createChildMatch(data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/ChildMatchLookup`, data));
        });
    }

    function getChildrenByCentre(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/Children/centre/${centreId}`));
        });
    }

    function updateChildLink(id, data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/ChildMatchLookup/WinzEntry/${id}`, data));
        });
    }

    return {
        getChildMatchByCentre,
        deleteChildMatch,
        updateChildMatch,
        createChildMatch,
        getChildrenByCentre,
        updateChildLink
    }

}